<template>
  <v-container
    fluid
  >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        class="mb-2"
      />
      <v-btn
        color="primary"
        class="ms-2"
        @click="newItem()"
      >
        <i class="fas fa-layer-plus fa-lg me-2" />
        {{ $t('new') }}
      </v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="dataRows"
      :items-per-page="tableCPP"
      :search="search"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn-toggle class="me-2">
          <v-btn
            fab
            x-small
            depressed
            class="green"
            @click="showDetail(item)"
          >
            <i
              class="fal fa-list-alt fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="indigo"
            @click="showItem(item)"
          >
            <i
              class="fal fa-eye fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="warning"
            @click="editItem(item)"
          >
            <i
              class="fal fa-pencil fa-lg"
            />
          </v-btn>
          <v-btn
            fab
            x-small
            class="error"
            @click="deleteConfirm(item)"
          >
            <i
              class="fal fa-trash-alt fa-lg"
            />
          </v-btn>
        </v-btn-toggle>
      </template>
      <template v-slot:item.status_text="{ item }">
        <v-chip
          :color="getStatusColor(item.status_text)"
        >
          {{ $t(item.status_text) }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      :internal-activator="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span
            class="headline"
          >
            {{ formTitle }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="10"
              >
                <v-text-field
                  v-model="editedItem.title"
                  :label="$t('title')"
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2">{{ $t('status') }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.duration"
                  :label="$t('duration')"
                  type="number"
                />
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.max_score"
                  :label="$t('max_score')"
                  type="number"
                />
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.approve_score"
                  :label="$t('approve_score')"
                  type="number"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('description') }}</span>
                <ckeditor
                  v-model="editedItem.description"
                  :editor="editor"
                  :config="editorConfig"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('max_score_end') }}</span>
                <ckeditor
                  v-model="editedItem.max_score_end"
                  :editor="editor"
                  :config="editorConfig"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('approved_score_end') }}</span>
                <ckeditor
                  v-model="editedItem.approved_score_end"
                  :editor="editor"
                  :config="editorConfig"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <span>{{ $t('rejected_score_end') }}</span>
                <ckeditor
                  v-model="editedItem.rejected_score_end"
                  :editor="editor"
                  :config="editorConfig"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :loading="btnLoadingSave"
            :disabled="btnLoadingSave"
            @click="save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogShow"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="4"
                sm="9"
                md="10"
              >
                <p>{{ $t('id') }} : <strong>{{ editedItem.id }}</strong></p>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="2"
              >
                <v-switch
                  v-model="editedItem.status"
                  disabled
                >
                  <template
                    v-slot:prepend
                  >
                    <span class="mt-1 me-2 text-no-wrap">{{ $t('status') + ` : ` + $t(editedItem.status_text) }}</span>
                  </template>
                </v-switch>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('title') }} : <strong>{{ editedItem.title }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('order') }} : <strong>{{ editedItem.order }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('description') }} : </p>
                <ckeditor
                  v-model="editedItem.description"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('max_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.max_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('approved_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.approved_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <p>{{ $t('rejected_score_end') }} : </p>
                <ckeditor
                  v-model="editedItem.rejected_score_end"
                  :editor="editor"
                  :config="editorConfig"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-divider />
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('created_at') }} : <strong>{{ editedItem.created_at }}</strong></p>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <p>{{ $t('updated_at') }} : <strong>{{ editedItem.updated_at }}</strong></p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDetail"
      :persistent="true"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
            >
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>{{ $t('title') }}</th>
                      <th>{{ $t('hint') }}</th>
                      <th>{{ $t('kind') }}</th>
                      <th>{{ $t('required') }}</th>
                      <th>{{ $t('order') }}</th>
                      <th>{{ $t('score') }}</th>
                      <th>{{ $t('actions') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isParent">
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.title"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.hint"
                        />
                      </td>
                      <td colspan="2">
                        زیر مجموعه
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.order"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.score"
                        />
                      </td>
                      <td>
                        <v-btn-toggle class="me-2">
                          <v-btn
                            fab
                            x-small
                            depressed
                            class="green"
                            :disabled="btnLoadingDetailSave"
                            :loading="btnLoadingDetailSave"
                            @click="saveDetail(item)"
                          >
                            <i
                              class="fal fa-save fa-lg"
                            />
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            class="error"
                            @click="cancelParentDetail()"
                          >
                            <i
                              class="fal fa-times fa-lg"
                            />
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                    </tr>
                    <tr v-else>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.title"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.hint"
                        />
                      </td>
                      <td>
                        <v-select
                          v-model="editedDetailItem.kind"
                          :label="$t('kind')"
                          :items="kindRows"
                          item-text="display"
                          item-value="dbItem"
                        />
                      </td>
                      <td>
                        <v-switch
                          v-model="editedDetailItem.required"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.order"
                        />
                      </td>
                      <td>
                        <v-text-field
                          v-model="editedDetailItem.score"
                        />
                      </td>
                      <td>
                        <v-btn-toggle class="me-2">
                          <v-btn
                            fab
                            x-small
                            depressed
                            class="green"
                            :disabled="btnLoadingDetailSave"
                            :loading="btnLoadingDetailSave"
                            @click="saveDetail(item)"
                          >
                            <i
                              class="fal fa-save fa-lg"
                            />
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            class="error"
                            @click="cancelDetail()"
                          >
                            <i
                              class="fal fa-times fa-lg"
                            />
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                    </tr>
                    <tr
                      v-for="item in detailItem"
                      :key="item.id"
                    >
                      <td>{{ item.title }}</td>
                      <td>{{ item.hint }}</td>
                      <td>{{ $t(item.kind_text) }} {{ item.parent_id }}</td>
                      <td>{{ $t(item.required_text) }}</td>
                      <td>{{ item.order }}</td>
                      <td>{{ item.score }}</td>
                      <td>
                        <v-btn-toggle class="me-2">
                          <v-btn
                            v-if="item.kind === 4 || item.kind === 6"
                            fab
                            x-small
                            class="green"
                            @click="addChildDetail(item)"
                          >
                            <i
                              class="fal fa-plus fa-lg"
                            />
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            class="warning"
                            @click="editDetail(item)"
                          >
                            <i
                              class="fal fa-pencil fa-lg"
                            />
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            class="error"
                            :disabled="btnLoadingDetailDetail"
                            :loading="btnLoadingDetailDetail"
                            @click="deleteDetail(item)"
                          >
                            <i
                              class="fal fa-trash-alt fa-lg"
                            />
                          </v-btn>
                        </v-btn-toggle>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-bottom-sheet
        v-model="deleteSheet"
        persistent
        inset
      >
        <v-sheet
          class="text-center"
          height="200px"
        >
          <v-btn
            class="mt-6"
            color="error"
            :loading="btnLoadingDelete"
            :disabled="btnLoadingDelete"
            @click="deleteItem(editedItem)"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn
            class="mt-6 ms-2"
            color="green"
            @click="deleteSheet = !deleteSheet"
          >
            {{ $t('close') }}
          </v-btn>
          <div class="py-3">
            {{ $t('permanently_delete?') }} {{ $t('you_can_not_undo.') }}
            <p class="pt-3">
              {{ $t('id') }} : <strong>{{ editedItem.id }}</strong> ,
              {{ $t('title') }} : <strong>{{ editedItem.title }}</strong>
            </p>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  export default {
    name: 'Operations',
    data () {
      return {
        headers: [],
        dataRows: [],
        kindRows: [
          { dbItem: 1, display: this.$t('text') },
          { dbItem: 2, display: this.$t('email') },
          { dbItem: 3, display: this.$t('textarea') },
          { dbItem: 4, display: this.$t('list') },
          { dbItem: 5, display: this.$t('checkbox') },
          { dbItem: 6, display: this.$t('radio') },
          { dbItem: 7, display: this.$t('file') },
          { dbItem: 8, display: this.$t('hidden') },
        ],
        dynamicColumns: [],
        tableCPP: 0,
        search: '',
        loading: true,
        dialog: false,
        dialogShow: false,
        dialogDetail: false,
        editedIndex: -1,
        editedItem: {},
        defaultItem: {},
        detailItem: {},
        editedDetailItem: {},
        editedDetailIndex: -1,
        formTitle: '',
        deleteSheet: false,
        btnLoadingDelete: false,
        btnLoadingSave: false,
        btnLoadingDetailSave: false,
        btnLoadingDetailDetail: false,
        isParent: false,
        Parent: null,
        snackbar: false,
        snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
        snackbarText: '',
        editor: ClassicEditor,
        editorConfig: {
          language: {
            ui: 'en',
            content: 'fa',
          },
          toolbar: [
            'undo',
            'redo',
            'fontColor',
            'fontBackgroundColor',
            'fontSize',
            '|',
            'bold',
            'italic',
            'underline',
            'removeFormat',
            'alignment',
            'bulletedList',
            'numberedList',
            'horizontalLine',
            '|',
            'link',
            'imageUpload',
            'insertTable',
            'mediaEmbed',
          ],
          image: {
            toolbar: [
              'imageTextAlternative',
              'imageStyle:full',
              'imageStyle:side',
            ],
          },
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells',
            ],
          },
        },
      }
    },
    async created () {
      await this.getData()
      await this.getOptions()
      await this.getDynamicColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showByTitle', {
          title: 'Forms-CPP',
        }).then(
          response => {
            const result = response.data.Option
            this.tableCPP = parseInt(result.value)
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showByTitle|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showByTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getHeaders () {
        this.$http.post('options/showTableHeader', {
          title: 'Forms-TH-Operations',
        }).then(
          response => {
            const result = response.data.Option
            this.headers = []
            this.headers.push({ text: this.$t('id'), value: 'id' })
            result.forEach(o => {
              this.headers.push({
                text: this.$t((typeof this.dynamicColumns[o.value] !== 'undefined') ? this.dynamicColumns[o.value] : o.value),
                value: o.value,
              })
            })
            this.headers.push({ text: this.$t('actions'), value: 'actions', sortable: false })
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': options/showTableHeader|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showTableHeader|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'forms',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = this.$t(o.title)
            })
            this.getHeaders()
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getData () {
        this.$http.post('forms/index').then(
          response => {
            this.dataRows = response.data.Forms
            this.editedItem = Object.assign({}, this.dataRows[0])
            const tempArray = []
            Object.keys(this.editedItem).forEach(function (item) {
              Object.assign(tempArray, { [item]: null })
            })
            this.defaultItem = tempArray
            this.loading = false
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/index|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/index|902'
          this.snackbar = true
          console.log(error)
        })
      },
      newItem () {
        this.formTitle = this.$t('new')
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = true
      },
      addChildDetail (item) {
        this.editedDetailItem = {}
        this.isParent = true
        this.Parent = item.id
        this.editedDetailItem.kind = item.kind === 4 ? 9 : 10
      },
      editItem (item) {
        this.formTitle = this.$t('edit')
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      editDetail (item) {
        this.editedDetailIndex = this.detailItem.indexOf(item)
        this.editedDetailItem = Object.assign({}, item)
      },
      cancelDetail () {
        this.editedDetailItem = {}
        this.editedDetailIndex = -1
      },
      cancelParentDetail () {
        this.isParent = false
        this.Parent = null
        this.editedDetailItem = {}
      },
      deleteConfirm (item) {
        this.editedItem = Object.assign({}, item)
        this.deleteSheet = true
      },
      showItem (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogShow = true
      },
      showDetail (item) {
        this.detailItem = []
        this.editedIndex = this.dataRows.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDetail = true
        this.$http.post('forms/showDetails', {
          formId: this.editedItem.id,
        }).then(
          response => {
            this.detailItem = response.data.FormDetails
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/showDetail|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/showDetail|902'
          this.snackbar = true
          console.log(error)
        })
      },
      deleteItem (item) {
        this.btnLoadingDelete = true
        this.$http.post('forms/delete', {
          id: item.id,
        }).then(
          response => {
            const index = this.dataRows.indexOf(this.dataRows.find(x => x.id === item.id))
            this.dataRows.splice(index, 1)
            this.deleteSheet = false
            this.btnLoadingDelete = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.btnLoadingDelete = false
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/delete|901'
              this.snackbar = true
            }
          }).catch(error => {
          this.btnLoadingDelete = false
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/delete|902'
          this.snackbar = true
          console.log(error)
        })
      },
      deleteDetail (item) {
        this.btnLoadingDetailDetail = true
        this.$http.post('forms/deleteDetail', {
          id: item.id,
        }).then(
          response => {
            const index = this.detailItem.indexOf(this.detailItem.find(x => x.id === item.id))
            this.detailItem.splice(index, 1)
            this.btnLoadingDetailDetail = false
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_deleted')
            this.snackbar = true
          },
          error => {
            if (error.data.code === 2001) {
              this.$router.push('/login')
            } else {
              this.snackbarColor = 'error'
              this.snackbarText = this.$t('server_error') + ': forms/delete|901'
              this.snackbar = true
              this.btnLoadingDetailDetail = false
            }
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': forms/delete|902'
          this.snackbar = true
          this.btnLoadingDetailDetail = false
          console.log(error)
        })
      },
      save () {
        this.btnLoadingSave = true
        if (this.editedIndex > -1) {
          this.$http.post('forms/update', this.editedItem).then(
            response => {
              Object.assign(this.dataRows[this.editedIndex], this.editedItem)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': forms/update|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': forms/update|902'
            this.snackbar = true
            console.log(error)
          })
        } else {
          this.editedItem.language_id = 1
          this.$http.post('forms/create', this.editedItem).then(
            response => {
              this.dataRows.push(response.data.Forms)
              this.btnLoadingSave = false
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
              this.close()
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': forms/create|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': forms/create|902'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      saveDetail () {
        this.btnLoadingDetailSave = true
        this.editedDetailItem.form_id = this.editedItem.id
        this.editedDetailItem.parent_id = this.Parent
        if (this.editedDetailIndex > -1) {
          this.$http.post('forms/updateDetail', this.editedDetailItem).then(
            response => {
              this.editedDetailItem.required_text = this.editedDetailItem.required ? 'required' : 'not_required'
              switch (this.editedDetailItem.kind) {
                case 1:
                  this.editedDetailItem.kind_text = 'text'
                  break
                case 2:
                  this.editedDetailItem.kind_text = 'email'
                  break
                case 3:
                  this.editedDetailItem.kind_text = 'textarea'
                  break
                case 4:
                  this.editedDetailItem.kind_text = 'list'
                  break
                case 5:
                  this.editedDetailItem.kind_text = 'checkbox'
                  break
                case 6:
                  this.editedDetailItem.kind_text = 'radio'
                  break
                case 7:
                  this.editedDetailItem.kind_text = 'file'
                  break
                case 8:
                  this.editedDetailItem.kind_text = 'hidden'
                  break
                case 9:
                  this.editedDetailItem.kind_text = 'list detail'
                  break
                case 10:
                  this.editedDetailItem.kind_text = 'radio detail'
                  break
              }
              Object.assign(this.detailItem[this.editedDetailIndex], this.editedDetailItem)
              this.btnLoadingDetailSave = false
              this.isParent = false
              this.Parent = null
              this.editedDetailItem = {}
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_updated')
              this.snackbar = true
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingDetailSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': forms/update|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingDetailSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': forms/update|902'
            this.snackbar = true
            console.log(error)
          })
        } else {
          this.$http.post('forms/createDetail', this.editedDetailItem).then(
            response => {
              this.detailItem.push(response.data.FormDetail)
              this.btnLoadingDetailSave = false
              this.isParent = false
              this.Parent = null
              this.editedDetailItem = {}
              this.snackbarColor = 'success'
              this.snackbarText = this.$t('item_inserted')
              this.snackbar = true
            },
            error => {
              if (error.data.code === 2001) {
                this.$router.push('/login')
              } else {
                this.btnLoadingDetailSave = false
                this.snackbarColor = 'error'
                this.snackbarText = this.$t('server_error') + ': forms/create|901'
                this.snackbar = true
              }
            }).catch(error => {
            this.btnLoadingDetailSave = false
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': forms/create|902'
            this.snackbar = true
            console.log(error)
          })
        }
      },
      close () {
        this.dialog = false
        this.dialogShow = false
        this.dialogImages = false
        this.dialogDetail = false
        this.isParent = false
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      },
      getStatusColor (text) {
        let returnColor
        switch (text) {
          case 'deactivate':
            returnColor = 'red'
            break
          case 'active':
            returnColor = 'green'
            break
          case 'locked':
            returnColor = 'purple'
            break
          case 'unknown':
            returnColor = 'yellow'
            break
          default:
            returnColor = 'yellow'
        }
        return returnColor
      },
    },
  }
</script>

<style scoped>

</style>
